<template lang="pug">
// 直向(左側)
#menu.footer-content.flex.justify-around.items-end.mx-auto.h-full.mt-2.pb-12(v-if="isVertical", v-show="isFooterLoadingCheck", :class="[orientation, hasBackdrop ? 'text-white' : '']")
  // 直式時
  // 角色選單
  button.gtm-function.flex.flex-col.items-center.w-full(v-if="!isTestUser", data-location="lobby", data-icon="Mission", @click="showModalFunc('ModalMission', 'Mission')")
    .relative.pointer-events-none(:class="[isVertical ? 'h-11' : 'h-10', 'xs:h-12']")
      .badge.absolute.top-0.-start-1.flex.justify-center.items-center.rounded-full.w-5.h-5.text-primary-text.text-xs(v-if="missionUnread") {{ missionUnread }}
      img.h-full.object-contain(:src="getCustomizedData('Mission').image || missionIcon")
    span.foot-item-text {{ getCustomizedData('Mission').name || $t('common.promotion') }}
  .position-2(v-if="!isTestUser && (position2 === 'DIAMOND_SHOP' || hasFriendActivity)")
    template(v-if="position2 === 'DIAMOND_SHOP' && !hasFriendActivity")
      button.gtm-function.flex.flex-col.items-center.w-full(data-location="lobby", data-icon="Diamond Shop", @click="showModalFunc('ModalDiamondShop')")
        .pointer-events-none(:class="[isVertical ? 'h-11' : 'h-10', 'xs:h-12']")
          img.h-full.object-contain(:src="getCustomizedData('Diamond').image || diamondIcon")
        span.foot-item-text {{ getCustomizedData('Diamond').name || $t('common.diamond') }}
    template(v-else)
      button.gtm-function.flex.flex-col.items-center.w-full(data-location="lobby", data-icon="Affiliate", @click="friendsClickHandler")
        .relative.pointer-events-none(:class="[isVertical ? 'h-11' : 'h-10', 'xs:h-12']")
          .badge.absolute.top-0.-start-1.flex.justify-center.items-center.rounded-full.w-5.h-5.text-primary-text.text-xs(v-if="friendUnread && hasFriendActivity") {{ friendUnread }}
          img.h-full.object-contain(:src="getCustomizedData('Friends').image || affiliateIcon")
        span.foot-item-text {{ getCustomizedData('Friends').name || $t('common.friends') }}
  button.gtm-function.flex.flex-col.items-center.w-full(v-if="showRankings", data-location="lobby", data-icon="Rank", @click="showModalFunc('ModalLeaderboard')")
    .pointer-events-none(:class="[isVertical ? 'h-11' : 'h-10', 'xs:h-12']")
      img.h-full.object-contain(:src="getCustomizedData('Ranking').image || leaderboardIcon")
    span.foot-item-text {{ getCustomizedData('Ranking').name || $t('common.leaderboard') }}
  button.gtm-function.flex.flex-col.items-center.w-full(v-if="!isTestUser", data-location="lobby", data-icon="Inbox", @click="showModalFunc('ModalInbox', 'Inbox')")
    .relative.pointer-events-none(:class="[isVertical ? 'h-11' : 'h-10', 'xs:h-12']")
      .badge.absolute.top-0.-start-1.flex.justify-center.items-center.rounded-full.w-5.h-5.text-primary-text.text-xs(v-if="inboxUnread") {{ inboxUnread }}
      img.h-full.object-contain(:src="getCustomizedData('Inbox').image || inboxIcon")
    span.foot-item-text.tracking-tight {{ getCustomizedData('Inbox').name || $t('common.inbox') }}
  button.gtm-function.flex.flex-col.items-center.w-full(v-if="fanPage", data-location="lobby", data-icon="FanPage", @click="openExternalLink(fanPage.link)")
    .pointer-events-none(:class="[isVertical ? 'h-11' : 'h-10', 'xs:h-12']")
      img.h-full.object-contain(:src="fanPage?.image || fanpageIcon")
    span.foot-item-text {{ $t('common.fbFanPage') }}
// 橫向
#menu.footer-content.flex.justify-around.items-end.mx-auto.h-full(v-else, v-show="isFooterLoadingCheck", :class="orientation")
  // 角色選單
  .relative.w-17(:class="isGuest && fanPage ? 'hidden portrait:block' : ''")
    Drawer
  button.gtm-function(v-if="fanPage", :class="isGuest ? 'block portrait:hidden' : 'hidden'", data-location="lobby", data-icon="FanPage", @click="openExternalLink(fanPage.link)")
    .pointer-events-none(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-11']")
      img.w-full.h-full.object-contain(:src="fanPage?.image || fanpageIcon")
    span.absolute.inset-x-0.bottom-1.leading-none(class="portrait:bottom-0") {{ $t('common.fbFanPage') }}
  button.gtm-function(v-if="!isTestUser", data-location="lobby", data-icon="Mission", class="portrait:hidden", @click="showModalFunc('ModalMission', 'Mission')")
    .pointer-events-none(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-11']")
      img.w-full.h-full.object-contain(:src="getCustomizedData('Mission').image || missionIcon")
    span.absolute.inset-x-0.bottom-1.leading-none(class="portrait:bottom-0") {{ getCustomizedData('Mission').name || $t('common.promotion') }}
    .badge.absolute.-top-1.end-2.flex.justify-center.items-center.rounded-full.w-5.h-5.text-primary-text.text-xs(v-if="missionUnread") {{ missionUnread }}
  .position-2(v-if="!isTestUser && (position2 === 'DIAMOND_SHOP' || hasFriendActivity)", class="portrait:hidden")
    template(v-if="position2 === 'DIAMOND_SHOP' && !hasFriendActivity")
      button.gtm-function(class="portrait:hidden", data-location="lobby", data-icon="Diamond Shop", @click="showModalFunc('ModalDiamondShop')")
        .pointer-events-none(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-12']")
          img.w-full.h-full.object-contain(:src="getCustomizedData('Diamond').image || diamondIcon")
        span.absolute.inset-x-0.bottom-1 {{ getCustomizedData('Diamond').name || $t('common.diamond') }}
    template(v-else)
      button.gtm-function(class="portrait:hidden", data-location="lobby", data-icon="Affiliate", @click="friendsClickHandler")
        .pointer-events-none(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-11']")
          img.w-full.h-full.object-contain(:src="getCustomizedData('Friends').image || affiliateIcon")
        span.absolute.inset-x-0.bottom-1.leading-none(class="portrait:bottom-0") {{ getCustomizedData('Friends').name || $t('common.friends') }}
        .badge.absolute.-top-1.end-2.flex.justify-center.items-center.rounded-full.w-5.h-5.text-primary-text.text-xs(v-if="friendUnread && hasFriendActivity") {{ friendUnread }}
  // 中柱
  client-only
    .relative.w-50.mx-1(v-if="showDownload && !isVertical")
      .absolute.inset-x-0.bottom-0.flex.h-13(class="rtl:flex-row-reverse")
        a.download.flex-1.h-full.cursor-pointer.bg-contain.bg-bottom.bg-no-repeat(:href="getDownloadLink", data-location="lobby", data-icon="DownloadApp", target="_blank", rel="nofollow me noopener noreferrer", :style="downloadButtonStyle", @click="setDownloadGuide")
        .signup.flex-1.h-full.cursor-pointer.bg-contain.bg-bottom.bg-no-repeat(:style="signupButtonStyle", @click="showModalFunc('ModalGuestLogin')")
    .relative.w-50.mx-1(v-else-if="(hasUserInfo || isGuest) && !isTestUser && !isVertical && !poCurrencyEnable")
      .absolute.inset-x-0.bottom-0.flex.h-13(class="rtl:flex-row-reverse")
        .gtm-deposit-link.flex-1.h-full.cursor-pointer.bg-contain.bg-bottom.bg-no-repeat(data-location="depositIcon", :style="depositButtonStyle", @click="clickDeposit()")
        .withdraw.gtm-function.flex-1.h-full.cursor-pointer.bg-contain.bg-bottom.bg-no-repeat(data-location="lobby", :style="withdrawButtonStyle", data-icon="Withdraw", @click="showModalFunc('ModalWithdrawProxy', 'Withdraw')")
  button.gtm-function(v-if="showRankings", data-location="lobby", data-icon="Rank", class="portrait:hidden", @click="showModalFunc('ModalLeaderboard', 'Rank')")
    .pointer-events-none(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-11']")
      img.w-full.h-full.object-contain(:src="getCustomizedData('Ranking').image || leaderboardIcon")
    span.absolute.inset-x-0.bottom-1.leading-none(class="portrait:bottom-0") {{ getCustomizedData('Ranking').name || $t('common.leaderboard') }}
  button.gtm-function(v-if="!isTestUser", data-location="lobby", data-icon="Inbox", class="portrait:hidden", @click="showModalFunc('ModalInbox', 'Inbox')")
    .pointer-events-none(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-11']")
      img.w-full.h-full.object-contain(:src="getCustomizedData('Inbox').image || inboxIcon")
    span.absolute.inset-x-0.bottom-1.leading-none.tracking-tight(class="portrait:bottom-0") {{ getCustomizedData('Inbox').name || $t('common.inbox') }}
    .badge.absolute.-top-1.end-2.flex.justify-center.items-center.rounded-full.w-5.h-5.text-primary-text.text-xs(v-if="inboxUnread") {{ inboxUnread }}
  .relative
    CsMenu(v-if="showCsMenu", position="footer", @close="closeCustomerService")
    button.gtm-function(v-if="!isTestUser", :disabled="!isCustomerServiceEnable", data-location="lobby", data-icon="LiveChat", @click="showCustomerService")
      .pointer-events-none.flex.justify-center(:class="[isVertical ? 'h-8' : 'h-10', 'xs:h-11']")
        img.mb-1(v-if="getServiceImage", :src="getServiceImage")
        img.w-full.h-full.object-contain(v-else, :src="getCustomizedData('Service').image || livechatIcon")
      span.absolute.inset-x-0.bottom-1.leading-none(class="portrait:bottom-0") {{ getCustomizedData('Service').name || $t('common.service') }}
</template>

<script setup>
import affiliateIcon from 'assets/images/footer/mainmenu_icon_affiliate_normal.png'
import diamondIcon from 'assets/images/footer/mainmenu_icon_diamond_normal.png'
import fanpageIcon from 'assets/images/footer/mainmenu_icon_fanpage_normal.png'
import inboxIcon from 'assets/images/footer/mainmenu_icon_inbox_normal.png'
import leaderboardIcon from 'assets/images/footer/mainmenu_icon_leaderboard_normal.png'
import livechatIcon from 'assets/images/footer/mainmenu_icon_livechat_normal.png'
import missionIcon from 'assets/images/footer/mainmenu_icon_mission_normal.png'
import { storeToRefs } from 'pinia'
import { ref, computed, watch, onBeforeUnmount } from 'vue'

import { useRuntimeConfig } from '#app'
import { useI18n } from '#imports'
import { activityApi, gameApi } from '@/api'
import { useLayout } from '@/composables/core/useLayout'
import { useSite } from '@/composables/core/useSite'
import { useUserInfo } from '@/composables/user/useUserInfo'
import { useMainStore } from '@/stores/main'
import { getCustomizedMenuItem } from '@/utils/menuHelper'
import { isTrue } from '@/utils/siteConfigChecker'

// Props
const props = defineProps({
  orientation: {
    type: String,
    default: 'horizontal',
  },
  hasBackdrop: {
    type: Boolean,
    default: false,
  },
})

const config = useRuntimeConfig()
const { mailBoxInfo } = useCommon()
const { $request, $SoundControl, $analytics } = useNuxtApp()
const { locale } = useI18n()
const { verify } = useVerify()
const { getFrontCdnUrl } = useCdnAssets()

const { activityList, hasFriendActivity } = useActivity(`footbar-${props.orientation}`)
const { otherRewardList, pointsRewardList, rewardList } = useReward()
const { userInfo, hasUserInfo } = useUserInfo({ autoInit: false })
const { isLoggedIn, isGuest } = useAuthToken()

const mainStore = useMainStore()
const { getDownloadLink, downloadVisible, getFreeGameList, navigator } = storeToRefs(mainStore)
const { setModal, setModalParams, setDownloadGuide, setFreeGameList } = mainStore

const { csChat, depositDefaultBonusPageEnable, diamondShopEnable, diamondShopExchangeMode, fanPage, poCurrencyEnable, promotionsRanking } = useSite()
const { mainMenu } = useLayout()

// Data
const siteName = config.public.clientId
const position2 = config.public.footerPosition2
const timeoutId = ref(null)

// 客服選單狀態（共享）
const { showCsMenu, showCustomerService, closeCustomerService } = useCustomerServiceMenu()

// Computed
const getActivityRankings = computed(() => {
  // 檢查是否有排行榜相關活動
  const rankingTemplates = [
    'Template_level_ranking', // Level Ranking
    'Template_points_ranking', // Points Ranking
    'Template_game_tournament_dragon', // 龍榜
    'Template_game_tournament_tiger', // 虎榜
    'Template_games_tournament', // Tournament活動
  ]
  // 檢查活動列表中是否包含排行榜模板
  const hasRankingTemplate = (activityList.value || []).some((item) => rankingTemplates.includes(item.template))
  return hasRankingTemplate
})

const showRankings = computed(() => {
  const promotionsRankingEnabled = promotionsRanking.value
  // console.log('*是否有排行榜相關活動:', getActivityRankings.value, '*Promotion排行榜是否開啟:', promotionsRankingEnabled)
  // 排行榜顯示：存在任何排行榜活動 或 promotionsRanking為true
  // 排行榜不顯示：不存在任何排行榜活動 且 promotionsRanking為false/undefined/null
  return getActivityRankings.value || promotionsRankingEnabled
})

const hideActivityWallet = computed(() => {
  return config.public.hideActivityWallet ? JSON.parse(config.public.hideActivityWallet) : false
})

const isVertical = computed(() => {
  return props.orientation === 'vertical'
})

const isTestUser = computed(() => {
  return userInfo.value?.scope === 'testuser'
})

const showDownload = computed(() => {
  return downloadVisible.value && isGuest.value
})

const freeGameAvailable = computed(() => {
  return (getFreeGameList.value || []).filter((item) => item.receiveStatus === 'PENDING' || item.receiveStatus === 'PLAYING').length
})

const unReceiveRewards = computed(() => {
  const unReceiveOthersCount = otherRewardList.value?.filter((item) => item.receiveStatus === 0)?.length || 0

  if (diamondShopEnable.value) {
    const unReceivePointsCount = pointsRewardList.value?.filter((item) => item.receiveStatus === 0)?.length || 0
    return unReceivePointsCount + unReceiveOthersCount
  } else {
    return unReceiveOthersCount
  }
})

const inboxUnread = computed(() => {
  return (mailBoxInfo.value?.rows || 0) + unReceiveRewards.value + freeGameAvailable.value
})

const missionUnread = computed(() => {
  const unreadCount = activityList.value?.filter((item) => item.unread && item.alreadyAttended === 0)?.length
  return unreadCount
})

const friendUnread = computed(() => {
  const filterList = rewardList.value?.filter((item) => item.activityType === 20)
  const unReceivedCount = filterList?.filter((item) => item.receiveStatus === 0)?.length
  return unReceivedCount
})

const isCustomerServiceEnable = computed(() => {
  return csChat.value?.some((item) => isTrue(item.enable))
})

const getServiceImage = computed(() => {
  const enableCS = csChat.value?.filter((item) => isTrue(item.enable))

  if (!enableCS || enableCS.length === 0) {
    return false
  }

  // 如果只有開啟一個客服選項
  if (enableCS.length === 1) {
    const firstCS = enableCS[0]
    if (firstCS.image) {
      return firstCS.image
    } else {
      return getFrontCdnUrl(`images/affiliate/affiliate_btn_${firstCS.name}_normal.png`)
    }
  }

  return false
})

const downloadButtonStyle = computed(() => {
  return {
    '--bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_download_{locale}_normal.png')})`,
    '--active-bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_download_{locale}_pressed.png')})`,
  }
})

const signupButtonStyle = computed(() => {
  return {
    '--bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_signup_{locale}_normal.png')})`,
    '--active-bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_signup_{locale}_pressed.png')})`,
  }
})

const depositButtonStyle = computed(() => {
  return {
    '--bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_deposit_{locale}_normal.png')})`,
    '--active-bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_deposit_{locale}_pressed.png')})`,
  }
})

const withdrawButtonStyle = computed(() => {
  return {
    '--bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_withdrawal_{locale}_normal.png')})`,
    '--active-bg': `url(${getFrontCdnUrl('images/footer/mainmenu_btn_withdrawal_{locale}_pressed.png')})`,
  }
})

const isFooterLoadingCheck = computed(() => {
  // 等待 navigator 設定完成後再顯示，避免中間按鈕區塊視覺跳動
  const isNavigatorReady = !!navigator.value?.userAgent
  return mainMenu.value && (userInfo.value?.level !== undefined || isGuest.value) && isNavigatorReady
})

const getFreeGame = async () => {
  const { data } = await $request.send(gameApi.getFreeGameList())
  setFreeGameList(data)
  timeoutId.value = setTimeout(() => {
    getFreeGame()
  }, 20000)
}

const friendsClickHandler = () => {
  if (isGuest.value) {
    setModal('ModalGuestLogin')
  } else {
    setModal('ModalFriends')
  }
}

const getCustomizedData = (type) => getCustomizedMenuItem(mainMenu.value, locale.value, type)

const openExternalLink = (url) => {
  const newWindow = window.open()
  newWindow.opener = null
  newWindow.location.href = url
}

const showModalFunc = (name, tag) => {
  if (tag) {
    $analytics.push({
      event: 'lobby_click',
      location: 'lobby',
      icon: tag,
    })
  }

  $SoundControl.sound.play('click')
  const includeModal = ['ModalDepositProxy', 'ModalWithdrawProxy', 'ModalInbox', 'ModalDiamondShop'].includes(name)
  // TODO：可移除
  if (tag === 'Convert') {
    setModalParams({ walletModeType: 'ACTIVITY', needVerify: false })
  } else {
    setModalParams({ walletModeType: 'CASH', needVerify: true })
  }

  if (includeModal && isGuest.value) {
    setModal('ModalGuestLogin')
  } else if (name === 'ModalDiamondShop' && diamondShopExchangeMode.value === '1') {
    setModal('ModalDiamondExchangeMax')
  } else {
    setModal(name)
  }
}

const clickDeposit = () => {
  $analytics.push({
    event: 'click_deposit',
    location: 'depositIcon',
  })

  if (hideActivityWallet.value) {
    showModalFunc('ModalDepositProxy')
  } else if (isLoggedIn.value && depositDefaultBonusPageEnable.value) {
    verify('DEPOSIT').then((isVerified) => {
      if (isVerified) {
        showModalFunc('ModalDepositPromotion')
      }
    })
  } else {
    showModalFunc('ModalDepositProxy')
  }
}

// Lifecycle
onBeforeUnmount(() => {
  if (timeoutId.value) {
    clearTimeout(timeoutId.value)
    timeoutId.value = null
  }
})
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";

button:disabled {
  filter: grayscale(1);
}

.gtm-deposit-link {
  background-image: var(--bg);
}

.gtm-deposit-link:active {
  background-image: var(--active-bg);
}

.newExchange {
  background-image: var(--new-exchange-bg);
}

.newExchange:active {
  background-image: var(--new-exchange-active-bg);
}

.withdraw {
  background-image: var(--bg);
}

.withdraw:active {
  background-image: var(--active-bg);
}

.exchange {
  background-image: var(--exchange-bg);
}

.exchange:active {
  background-image: var(--exchange-active-bg);
}

.download {
  background-image: var(--bg);
}

.download:active {
  background-image: var(--active-bg);
}

.signup {
  background-image: var(--bg);
}

.signup:active {
  background-image: var(--active-bg);
}

.badge {
  background-image: url('assets/images/common/mainmenu_icon_notice_normal.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

#menu.vertical {
  @apply landscape:hidden flex-col justify-start items-center overflow-y-auto;
}

#menu.vertical button {
  @apply relative mb-2;
}

#menu.vertical button span {
  @apply relative block text-xs leading-tight;
}

#menu.horizontal button {
  @apply relative w-18 pb-3 cursor-pointer xs:w-20 font-medium animate-in zoom-in;
}

#menu.horizontal button span {
  @apply text-shadow-header;
}

/* 防止日語過長換行 */
.gtm-function {
  @apply whitespace-nowrap;
}

.foot-item-text {
  @apply absolute inset-x-0 bottom-0 font-medium;
}
</style>
